import { render, staticRenderFns } from "./DocumentExtraFieldsGrid.vue?vue&type=template&id=16046309"
import script from "./DocumentExtraFieldsGrid.vue?vue&type=script&lang=js"
export * from "./DocumentExtraFieldsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports